// extracted by mini-css-extract-plugin
module.exports = {"navItem":"styles_navItem__3JuVB"};